import { fmtINR } from "../lib/api";

export const AgingBar = ({ aging, title = "Outstanding Aging" }) => {
  const buckets = [
    ["not_due", "Not due", aging.not_due || 0, "#1C2331"],
    ["d0_30", "0–30 days", aging.d0_30 || 0, "#F59E0B"],
    ["d31_60", "31–60 days", aging.d31_60 || 0, "#EA580C"],
    ["d60_plus", "60+ days", aging.d60_plus || 0, "#991B1B"],
  ];
  const total = buckets.reduce((s, b) => s + b[2], 0) || 1;
  return (
    <div className="bg-white border border-[#E6E4DD] rounded-sm p-6" data-testid="aging-bar">
      <h2 className="font-heading text-lg font-semibold text-[#0A0D14] mb-4">{title}</h2>
      <div className="flex h-2.5 w-full overflow-hidden rounded-full mb-4 bg-slate-100">
        {buckets.map(([key, , val, color]) => (
          <div key={key} style={{ width: `${(val / total) * 100}%`, background: color }} title={`${fmtINR(val)}`} />
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {buckets.map(([key, label, val, color]) => (
          <div key={key} data-testid={`aging-${key}`} className="border-l-2 pl-3" style={{ borderColor: color }}>
            <div className="text-xs uppercase tracking-wider text-[#8CA3A7]">{label}</div>
            <div className="font-mono tabular-nums text-sm mt-1" style={{ color }}>{fmtINR(val)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
